export { getProperty as getAtPath, setProperty as setAtPath, deleteProperty as deleteAtPath } from 'dot-prop';
export { excludeKeys as omit } from 'filter-obj';
export { default as pick } from 'object.pick';
export const lastElement = (elem) => {
    return elem.length ? elem[elem.length - 1] : undefined;
};
export const emptyObject = (obj) => Object.keys(obj || {}).length === 0;
export const undefinedCheck = (variable) => typeof variable === 'undefined';
export const digit2string = (i) => {
    // 0-9 -> 0-9; 10-35 > a-z; 36-61 -> A-Z
    return String.fromCharCode(i < 10 ? i + 48 : i < 36 ? i + 87 : i + 29);
};
export const jsonParse = (obj) => {
    try {
        if (obj) {
            return JSON.parse(obj);
        }
        return '';
    }
    catch (e) {
        return obj;
    }
};
